module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 3
// module chunks = 0